<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 md5 sm8>
          <h3 class="text-center">Edit Coupon</h3>
          <v-card>
            <v-card-text>
              <form @submit.prevent="saveCoupon">
                <v-text-field label="Coupon Code" v-model="coupon.code" maxLength="16" minLength="5" required="required" hint="Enter an ONLY alphanumeric code between 5 and 16 characters long. Spaces and special characters are not allowed" :placeholder="'e.g. SWEET16, WELCOME' + moment().year()" :error-messages="errors.code"></v-text-field>
                <v-text-field label="Expiry Date" v-model="coupon.expiry" type="date" :min="today" required="required" hint="Coupon won't work after this date" :error-messages="errors.expiry"></v-text-field>
                <v-text-field label="Discount" v-model="coupon.discount" type="number" step="0.01" min="0.01" max="100" hint="The discount applied" append-icon="%" :error-messages="errors.discount"></v-text-field>
                <v-text-field label="Limit" type="number" min="1" v-model="coupon.limit" hint="How many times should this coupon be applied before it's deemed invalid" required :error-messages="errors.limit"></v-text-field>
                <v-btn small type="submit" color="primary" class="pull-right" :loading="coupon.processing">
                  <v-icon left>{{ icons.create }}</v-icon>
                  Save
                </v-btn>
                <br>
              </form>
            </v-card-text>
            <v-card-actions class="py-0">
              <v-btn small @click="goTo('/coupons/' + edit.id)" title="Cancel">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'

  export default {
    name: 'EditCoupon',
    layout,
    props: [
      'errors',
      'edit'
    ],
    components: {},
    metaInfo () {
      return {
        title: 'Edit Coupon',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        coupon: this.$inertia.form({
          code: this.edit.code,
          expiry: this.edit.expiry,
          discount: this.edit.discount,
          limit: this.edit.limit,
          id: this.edit.id,
        })
      }
    },
    methods: {
      saveCoupon () {
        this.coupon.put('/coupons/' + this.coupon.id)
      },
    },
    computed: {
      today () {
        return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      },
    },
    watch: {
      'coupon.code': _.debounce(function (value) {
        if (value) {
          let re = '[^A-Za-z0-9_]'
          let cleaned = value.replace(new RegExp(re, 'gm'), '')
          this.coupon.code = cleaned.toUpperCase()
        }
      }, 2000)
    }
  }
</script>
